// @ts-strict-ignore
import React from 'react';
import {
  View,
  ImageBackground,
  StyleSheet,
  TouchableWithoutFeedback,
} from 'react-native-web';
import { ClientProviderProfile } from '../../../api/ProfileClientView';
import { getProfileLocation } from '../../../api/ProfileClientView/ProfileClientView';

import type { PublicProvider } from '../../../api/Providers';

import { googleMapURL, getStaticGoogleMapsUrl } from '../../../modules/maps/location';
import { clickable } from '../../../styles';

export type StaticMapProps = {
  profile: PublicProvider | ClientProviderProfile;
  onPress?: () => void;
  mapHeight?: number;
};

const StaticMap = ({
  profile,
  onPress,
  mapHeight = 165,
}: StaticMapProps) => {
  const location = getProfileLocation(profile);
  const mapProfileInfoAvailable = !!location?.zipcode;
  const googleMapsLink = mapProfileInfoAvailable ? googleMapURL(location) : '';
  const staticMapUrl = mapProfileInfoAvailable ? getStaticGoogleMapsUrl(location, {}) : '';

  return mapProfileInfoAvailable ? (
    <TouchableWithoutFeedback onPress={onPress}>
      <View
        style={clickable}
        testID="profile-static-map"
      >
        <View
          accessibilityRole="link"
          // trying to wrap the ImageBackground in other ways broke the styling/UI
          href={googleMapsLink}
          target="_blank"
          style={{
            display: 'flex',
            height: mapHeight,
            // @ts-expect-error Background images are not react native compatible
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        >
          <ImageBackground
            style={StyleSheet.absoluteFill}
            source={{
              uri: staticMapUrl,
            }}
            resizeMode="cover"
          />
        </View>
      </View>
    </TouchableWithoutFeedback>
  ) : null;
};

export default StaticMap;
